export default "__VITE_ASSET__CJ$fCMiL__"